import { useState } from "react";

import { SquareCard } from "@whoosh/features/src/Square/features/SquareCardEntry/types";

import { SquareGiftCardEntryModal } from "./AddGiftCard/components/SquareGiftCardEntry/SquareGiftCardEntry";
import { useCreateGiftCard } from "./AddGiftCard/hooks/useCreateGiftCard";

export const SquareGiftCardEntryModalWrapper = ({
  isOpen,
  setIsOpen,
  onCreateGiftCard,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onCreateGiftCard?: (giftCardId: string) => void;
}) => {
  const [createGiftCard, isCreatingGiftCard] = useCreateGiftCard(
    (giftCardId: string) => {
      setIsOpen(false);
      onCreateGiftCard?.(giftCardId);
    }
  );
  const [loading, setLoading] = useState(false);

  const handleCardEntryComplete = (cardDetails: SquareCard) => {
    createGiftCard({
      squareNonce: cardDetails.nonce,
    });
  };

  return isOpen ? (
    <SquareGiftCardEntryModal
      isOpen={isOpen}
      onCardEntryCancel={() => setIsOpen(false)}
      onCardEntryComplete={handleCardEntryComplete}
      loading={loading || isCreatingGiftCard}
      setLoading={setLoading}
    />
  ) : null;
};
